var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66667 8.86133H8C8.36819 8.86133 8.66667 9.0532 8.66667 9.28988V10.147C8.66667 10.3837 8.36819 10.5756 8 10.5756H2.66667C2.29848 10.5756 2 10.3837 2 10.147V9.28988C2 9.0532 2.29848 8.86133 2.66667 8.86133ZM2.66667 12.2889H5.33333C5.70152 12.2889 6 12.4808 6 12.7175V13.5746C6 13.8113 5.70152 14.0032 5.33333 14.0032H2.66667C2.29848 14.0032 2 13.8113 2 13.5746V12.7175C2 12.4808 2.29848 12.2889 2.66667 12.2889Z",
    fill: "#CFE6FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 5.42969H2.66667C2.29848 5.42969 2 5.62156 2 5.85824V6.71535C2 6.95204 2.29848 7.14391 2.66667 7.14391H10.6667C11.0349 7.14391 11.3333 6.95204 11.3333 6.71535V5.85824C11.3333 5.62156 11.0349 5.42969 10.6667 5.42969Z",
    fill: "#1080FF",
    fillOpacity: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 2.00195H2.66667C2.29848 2.00195 2 2.19382 2 2.43051V3.28762C2 3.5243 2.29848 3.71618 2.66667 3.71618H13.3333C13.7015 3.71618 14 3.5243 14 3.28762V2.43051C14 2.19382 13.7015 2.00195 13.3333 2.00195Z",
    fill: "#1080FF",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.22b849282a98f3bdb261743dc4bd7eea.svg";
export { ForwardRef as ReactComponent };